/**
 * Remove duplicates from array
 *
 * @param values
 */
export default (values) => {
    return [...new Set(values)];
}